var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgBlueTemp = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34993 7.69991V2.09998C6.34993 0.937989 5.41195 0 4.24996 0C3.08797 0 2.14998 0.937989 2.14998 2.09998V7.69991C1.30299 8.3369 0.75 9.35889 0.75 10.4999C0.75 12.4319 2.31798 13.9998 4.24996 13.9998C6.18194 13.9998 7.74992 12.4319 7.74992 10.4999C7.74992 9.35889 7.19692 8.3369 6.34993 7.69991ZM3.54997 2.09998C3.54997 1.71498 3.86496 1.39998 4.24996 1.39998C4.63495 1.39998 4.94995 1.71498 4.94995 2.09998H4.24996V2.79997H4.94995V4.19995H4.24996V4.89994H4.94995V6.29993H3.54997V2.09998Z",
    fill: "#006EB7"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBlueTemp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/blue-temp.b8fe0d05.svg";
export { ForwardRef as ReactComponent };